<template>
  <!-- 运行轨迹组件 -->
  <a-spin :spinning="loading">
    <IndoorTrack ref="IndoorTrack" :scene="scene" :points="sceneTrack" :personInfo="personInfo" @end="indoorTrackEnd"></IndoorTrack>
    <div class="main">
      <div class="left">
        <BaiDuMap 
          :idName="`map-track-${personInfo.key}`"
          @getMap="getMap"
          :hasCityControl="false"
          height="600"
        />

        <TrackSlide 
          class="slide"
          v-if="points.length > 0"
          @trackStart="trackStart"
          @pause="pause"
          @stop="stop"
          @speedChanged="speedChanged"
        />
      </div>
      <div class="right">
        <TimePick
          @getPoints="getPoints"
          :personInfo="personInfo"
          @isLoading="isLoading"
          @handleStop="handleStop"
        />
        <PersonData 
          v-if="showPersonal"
          :personInfo="personInfo"
          :alarmPoints="alarmPoints"
          :stayPoints="stayPoints"
          :allPoints="allPoints"
          :movePoints="movePoints"
          @setNoramlLabel="setNoramlLabel"
          @setAlarmInfoWindow="setAlarmInfoWindow"
          @setStayInfoWindow="setStayInfoWindow"
        />
      </div>
    </div>
  </a-spin>
</template>
<script>
import BaiDuMap from '../common/BMap'
import MapLuShu from '../../utils/MapLuShu'
import TrackSlide from './TrackSlide'
import TimePick from './PickTime'
import PersonData from './PersonData'
import funcs from '../../utils/getLocalPosition'
import moment from 'moment'
import {TransForm} from '@/assets/js/transform'
import {
  MarkerClusterer
} from '@assets/js/MarkerClusterer'
import config from '@/config';
import NormalPng from '../../assets/point_normal_icon.png'
import AlarmPng from '../../assets/point_warning_icon.png'
import radiusPng from '../../assets/point_radius_icon.png'
import MapInitControl from '../../utils/setMapInit'
import {computedLocationType} from '../../utils/homeFn'
import IndoorTrack from "./IndoorTrack.vue";
import {markerLabelStyle, hideLabelStyle, transparencyLabelStyle} from '../../config/globalConfig'
import bus from '../../bus/bus';

export default {
  components: {
    BaiDuMap,
    TrackSlide,
    TimePick,
    PersonData,
    IndoorTrack
  },
  props: {
    personInfo: {
      required: true
    }
  },
  data () {
    return {
      AlarmClusterer: null,
      StayClusterer: null,
      loading: false,
      map: '',
      LuShu: null,
      points: [],
      // 所有常驻点
      stayPoints: [],
      // 所有报警点
      alarmPoints: [],
      // 是否显示个人信息组件
      showPersonal: false,
      stayOverlays: [],
      alarmOverlays: [],
      movePoints: [],
      allPoints: [],
      allOverlays: [],
      scenesList: [],
      scene: null,
      sceneTrack: [],
      pointIndex: null,
      currentSceneId: null
    }
  },
  computed: {
    // 
  },
  methods: {
    computedLocationType,
    indoorTrackEnd(){
      console.log('this.pointIndex=' + this.pointIndex)
      if(this.pointIndex != null) {
        console.log('indoorTrackEnd',this.pointIndex)
        this.LuShu && this.LuShu.moveNext(this.pointIndex)
      }
    },
    showIndoorTrack(point,index){
      this.pointIndex = index
      if(point.scene && this.scenesList[point.scene]){
        let scene = this.scenesList[point.scene]
        if(scene){
          this.scene = scene
          this.sceneTrack = point.sceneTrack
          this.$refs["IndoorTrack"].showIndoorMap()
          console.log('当前点有室内轨迹：index =' + index + ',点个数：' + point.sceneTrack.length)
          return
        }
      }
      console.log('当前点没有室内轨迹，直接返回，index =' + index)
      this.LuShu && this.LuShu.moveNext(this.pointIndex)
    },
    initScenes(){
      this.scenesList = []
      this.$http.get(config.api.org_tree_url).then(resp => {
        let { code, result } = resp
        if(code === 0) {
          this.$http.get(config.api.get_scenes_fence + result.scenes).then(res => {
            if(res.code === 0) {
              this.initScenesMap(res.result)
            }
          })
        }
      })
    },
    initScenesMap(scenesTree) {
      for(let scenes of scenesTree) {
        if (scenes.type === 2 && scenes.data && scenes.data.type === 2) {
          this.scenesList[scenes.data.id] = scenes.data
        }
        if (scenes.children) {
          this.initScenesMap(scenes.children)
        }
      }
    },
    init () {
      this.map.clearOverlays()
      this.stayOverlays = []
      this.alarmOverlays = []
      this.allPoints = []
      this.allOverlays = []
    },
    // 添加一个自定义控件，返回地图初始位置
    addMapInitControl() {
      let myMapInitControl = new MapInitControl({
        anchor: window.BMAP_ANCHOR_TOP_RIGHT,
        offset: new window.BMap.Size(22, 130)
      })
      this.map.addControl(myMapInitControl)
    },
    // 判断是否是加载状态
    isLoading (statu) {
      this.loading = statu
      if (statu) {
        this.showPersonal = !statu
      }
    },

    handleStop() {
      this.LuShu && this.LuShu.stop();
      this.LuShu && this.LuShu.hide();
    },


    // 获取地图实例
    getMap (map) {
      this.map = map
      // this.points && this.initLuShu()
      // this.initLuShu()
      this.addMapInitControl()
    },
    transToBd09(coord_type, lng, lat) {
      let tmpLat = +lat
      let tmpLng = +lng
      let tmp
      if (coord_type == 'wgs84' || coord_type == 'WGS84') {
          tmp = TransForm.wgs84tobd09(tmpLng, tmpLat)
      } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
          tmp = TransForm.gcj02tobd09(tmpLng, tmpLat)
      } else {
          tmp = [tmpLng, tmpLat]
      }
      tmp = [tmp[0].toFixed(6), tmp[1].toFixed(6)]
      // return tmp
      return {
        coord_type: 'BD09',
        lng: Number(tmp[0]),
        lat: Number(tmp[1])
      }
    },
    createInfoWindow (i, addr) {
      const computedInfoWindowMode = (i) => {
        if (this.allPoints[i].stayTime) {
          return 'stay'
        } else if (this.allPoints[i].isAlarm == true) {
          return 'alarm'
        } else {
          return 'noraml'
        }
      }
      let mode = computedInfoWindowMode(i)
      if (mode == 'alarm') {
        return new BMap.InfoWindow(`
          <h3>${this.personInfo.姓名 || this.personInfo.Name}</h3>
          <p class="sub-title">${moment(this.allPoints[i].timestamp * 1000).format('YYYY-MM-DD HH:mm')}</p>
          <p class="sub-text">${addr}</p>
          <p class="sub-text">${this.$t('supervise.locationType')}: ${this.computedLocationType(this.allPoints[i].loc_type).value}</p>
          <p class="sub-text">${`${this.$t('global.alarmInfo')}:${this.allPoints[i].message}`}</p>
        `, {
          offset: new BMap.Size(-25, -15)
        })
      } else if (mode == 'stay') {
        return new BMap.InfoWindow(`
          <h3>${this.personInfo.姓名 || this.personInfo.Name}</h3>
          <p class="sub-title">${moment(this.allPoints[i].timestamp * 1000).format('YYYY-MM-DD HH:mm')}</p>
          <p class="sub-text">${addr}</p>
          <p class="sub-text">${this.$t('supervise.locationType')}: ${this.computedLocationType(this.allPoints[i].loc_type).value}</p>
          <p class="sub-text">${`${this.$t('global.stayTime') + moment.duration({seconds: this.allPoints[i].stayTime}).humanize()}`}</p>
        `, {
          offset: new BMap.Size(-25, -15)
        })
      } else {
        return new BMap.InfoWindow(`
          <h3>${this.personInfo.姓名 || this.personInfo.Name}</h3>
          <p class="sub-title">${moment(this.allPoints[i].timestamp * 1000).format('YYYY-MM-DD HH:mm')}</p>
          <p class="sub-text">${addr}</p>
          <p class="sub-text">${this.$t('supervise.locationType')}: ${this.computedLocationType(this.allPoints[i].loc_type).value}</p>
        `, {
          offset: new BMap.Size(-25, -15)
        })
      }
    },
    // 获取所有轨迹点
    getPoints (allData) {
      this.pointIndex = null
      // this.showPersonal = false
      // 重新取值的情况
      if (this.LuShu) {
        this.LuShu.stop()
        this.LuShu = null
      }
      this.init()
      // 1 获取所有数据
      let {filter, all} = allData
      // 转换坐标系至 BD09 即是 百度坐标系
      // let bd09Points = this.transToBd09(filter[0].coord_type, filter[0].lng, filter[0].lat)
      // filter.sort((a, b) => b.timestamp - a.timestamp)
      // this.rAllPoints = filter.map((item, index) => {
      //   item.id = index + 1
      //   return item
      // })
      this.rAllPoints = filter.map((item, index) => {
        if(item.scene) {
          item.sceneTrack.map(items => {
            return Object.assign({}, items, this.transToBd09(items.coord_type, items.lng, items.lat), {id: index + 1})
          })
        }
        return Object.assign({}, item, this.transToBd09(item.coord_type, item.lng, item.lat), {id: index + 1, type: item.scene ? 2 :undefined})
      })
      let bd09Points = filter.map((point, index) => {
        // let coord = this.transToBd09(point.coord_type, point.lng, point.lat)
        return Object.assign({}, point, this.transToBd09(point.coord_type, point.lng, point.lat), {index: index + 1})
      })
      this.allPoints = bd09Points
      let allPoints = bd09Points
      // 所有点暂时不转了
      let points = bd09Points.map((item, index) => {
        return new BMap.Point(item.lng, item.lat)
      })
      // 2 过滤所有有停留的点和报警点为特殊点
      let specailPoints = bd09Points.filter((item) => {
        return item.stayTime || item.isAlarm === true
      })
      this.movePoints = bd09Points.filter((item) => {
        return item.isAlarm === false && !item.stayTime
      })
      // 筛选出所有有报警信息的点
      let alarmPoints = bd09Points.filter((item) => {
        return item.isAlarm === true
      })
      this.stayPoints = specailPoints.filter((item) => {
        // 只有当停留时间大于5分钟的点才回被视为停留点，以免出现停留时间几秒的问题
        return item.stayTime
      })
      this.alarmPoints = alarmPoints

      let landmarkPois= [...specailPoints.map((item) => {
        return {
            lng: item.lng,
            lat: item.lat,
            html: item.stayTime ? `${moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm')}${this.personInfo.姓名 + this.$t('global.stayTime')}${moment.duration({seconds: item.stayTime}).humanize()}` : `${this.personInfo.姓名 || this.personInfo.Name}:${moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm') + this.$t('global.occurAlarm')}，${this.$t('global.reason')}:${item.message}`,
            pauseTime: 1,
            timestamp: item.timestamp
        }
      })]
      landmarkPois = landmarkPois.filter(item => {return item.lat != 'NaN' && item.lng != 'NaN'})
      landmarkPois.sort((a, b) => a.timestamp - b.timestamp)
      let icon
      for (let i = 0;i < allPoints.length; i++) {
        if(allPoints[i].lng == 'NaN' || allPoints[i].lat == 'NaN'){
            continue;
        }
        if(allPoints[i].radius > 200) {
          icon = radiusPng
        } else if(allPoints[i].isAlarm) {
          icon = AlarmPng
        } else {
          icon = NormalPng
        }
        let marker = new BMap.Marker(
          new BMap.Point(allPoints[i].lng, allPoints[i].lat),
          {
            icon: new BMap.Icon(icon,  new BMap.Size(70, 30)),
            offset: new BMap.Size(25, -15)
          }
        )
        let label = new BMap.Label(allPoints[i].index, {
          offset: new BMap.Size(2, -18)
        })
        label.setStyle(transparencyLabelStyle)
        marker.setLabel(label)
        // 不要直接push 会导致序号错乱问题，直接设置 arr[index] 会让数组出现空值区间，以后类似情况考虑使用HashMap来储存数据
        // this.allOverlays.push(marker)
        this.allOverlays[allPoints[i].index] = marker
        this.map.addOverlay(marker)
        // 特殊点的点击事件
        marker.addEventListener('click', async () => {
          // 将地图的经纬度点转为实际地址
          let geoc = new BMap.Geocoder()
          await geoc.getLocation(marker.getPosition(), (res) => {
            // address = res.address
            let addr = allPoints[i].address ? allPoints[i].address : res.address
            // if (res.surroundingPois.length > 0) {
            //   addr = res.address + res.surroundingPois[0].title
            // } else {
            //   addr = res.address
            // }
            // 打开信息窗口
            marker.setTop(true)
            marker.openInfoWindow(this.createInfoWindow(i, addr))
          })
        })
        
      }

      points = points.filter(item => {return item.lat != 0 && item.lng != 0})
      this.points = points
      if (this.points.length >= 1) {
        // 这里需要考虑是否需要将所有点按步行的路线解析出来
        // 划线
        //绘制箭头及其样式
//        let sy = new BMap.Symbol(BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW, {
//          scale: 0.4,//图标缩放大小
//          strokeColor:'#fff',//设置矢量图标的线填充颜色
//          strokeWeight: 1,//设置线宽
//        })
//        let icons = new BMap.IconSequence(sy, '5', '50', false)
        //绘制折线以及样式
        let line = new BMap.Polyline(this.points, {
          strokeColor: '#4353a2',
          strokeWeight: 6,
          strokeOpacity:0.8,//折线的透明度，取值范围0 - 1
          enableEditing: false,//是否启用线编辑，默认为false
          enableClicking: false,//是否响应点击事件，默认为true
          // icons:[icons]
        })
        // 添加覆盖物线
        this.map.addOverlay(line)
      }
      // 初始化路书
      this.initLuShu({
        landmarkPois: landmarkPois,
        speed: 3000,
        defaultContent: this.personInfo.姓名 || this.personInfo.Name
      })
      // 将地图可见区域调整到路径
      this.map.setViewport(this.points)
      // this.loading = false
      this.showPersonal = true
    },
    // 实例化路书
    initLuShu (opt) {
      if (this.LuShu) {
        // this.LuShu.hide()
        this.LuShu = null
      }
      this.LuShu = new MapLuShu(this.map, this.rAllPoints, opt,this.showIndoorTrack)
    },
    // 改变路书的移动速度
    speedChanged (speed) {
      this.LuShu.Lushu._opts.speed = speed
    },
    trackStart () {
      this.LuShu && this.LuShu.start()
    },
    pause () {
      this.LuShu && this.LuShu.pause()
    },
    stop () {
      this.LuShu && this.LuShu.stop()
      this.LuShu && this.LuShu.hide()
    },
    setAlarmInfoWindow (item) {
      let point = new BMap.Point(item.point.lng, item.point.lat)
      this.map && this.map.setCenter(point)
      this.allOverlays[item.index].setTop(true)
      this.allOverlays[item.index].openInfoWindow(this.createInfoWindow(item.index - 1, item.address))
    },
    setStayInfoWindow (item) {
      let point = new BMap.Point(item.point.lng, item.point.lat)
      this.map && this.map.setCenter(point)
      this.allOverlays[item.index].setTop(true)
      this.allOverlays[item.index].openInfoWindow(this.createInfoWindow(item.index - 1, item.address))
    },
    setNoramlLabel (item) {
      let point = new BMap.Point(item.point.lng, item.point.lat)
      this.map && this.map.setCenter(point)
      this.allOverlays[item.index].setTop(true)
      this.allOverlays[item.index].openInfoWindow(this.createInfoWindow(item.index - 1, item.address))
    },
  },
  mounted () {
    this.initScenes()
    bus.$on('setViewport', () => {
      if (this.map && this.points.length > 0) {
        this.map.setViewport(this.points)
      }
    })
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-column-gap: 10px;
  .left {
    .slide {
      width: 100%;
      box-sizing: border-box;
      box-shadow: 1px 1px 3px #aaa;
      padding: 10px;
      margin-top: 10px;
    }
  }
  .right {
    width: 100%;
    display: flex;
    flex-direction: column;
    // align-items: start;
    box-shadow: 1px 1px 5px #aaa;
  }
}


/deep/ .my-div-name-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
